import { render, staticRenderFns } from "./approve_details.vue?vue&type=template&id=2f256206&scoped=true"
import script from "./approve_details.vue?vue&type=script&lang=js"
export * from "./approve_details.vue?vue&type=script&lang=js"
import style0 from "./approve_details.vue?vue&type=style&index=0&id=2f256206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f256206",
  null
  
)

export default component.exports